import { parseISO, isAfter, isEqual } from 'date-fns';

import { Ticket } from '../../types/ticket';
import { Rule } from '../Rule';
import { RuleContext } from '../RuleContext';

export class CheckSalesOpeningRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets } = context;
    const now = new Date();

    return tickets.map((ticket) => {
      const updatedTypes = ticket.type.reduce((acc, type) => {
        const openSales = parseISO(type.beginSales);
        const salesClosed = parseISO(type.endSales);

        const isEqualsOpenSales = isEqual(now, openSales);
        const isAfterOpenSales = isAfter(now, openSales);
        const isAfterSalesClosed = isAfter(now, salesClosed);

        const canSell = (isEqualsOpenSales || isAfterOpenSales) && (isAfterOpenSales && !isAfterSalesClosed);

        acc.push({ ...type, canSell });

        return acc;
      }, [] as typeof ticket.type);

      const sortedTypes = updatedTypes.sort((prevTicket, nextTicket) => {
        return (nextTicket.canSell ? 1 : 0) - (prevTicket.canSell ? 1 : 0);
      });
      return { ...ticket, type : sortedTypes };
    });
  }
}
